import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from 'types'
import { context } from './context'
import { theme } from './theme'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  modules: {
    context,
    theme
  }
}

export default new Vuex.Store<RootState>(store)
